module.exports = __webpack_public_path__ + "static/media/water_level_5.4e8a2a7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/icons/water_level_5.png
// module id = 313
// module chunks = 2